import React from 'react';
import {
    EnumMemberItemControllerProps,
    EnumMemberItemViewProps,
} from './memberItemProps';
import { MemberItemController } from './memberItemInterface';

export function createMemberItemController(): MemberItemController {
    return {
        useProps(props): EnumMemberItemViewProps {
            const [isDragOver, setIsDragOver] = React.useState(false);
            const [isHovered, setIsHovered] = React.useState(false);
            const [isDragging, setIsDragging] = React.useState(false);
            const [insertPosition, setInsertPosition] = React.useState<'above' | 'below'>(
                'below'
            );

            const handleDragOver = (e: React.DragEvent) => {
                props.onDragOver(e);

                // Calculate mouse position relative to the element
                const rect = e.currentTarget.getBoundingClientRect();
                const mouseY = e.clientY;
                const elementMiddle = rect.top + rect.height / 2;

                // Determine if we're in the upper or lower half
                const isUpperHalf = mouseY < elementMiddle;
                setInsertPosition(isUpperHalf ? 'above' : 'below');
                setIsDragOver(true);
            };

            const handleDrop = (e: React.DragEvent) => {
                const insertBefore = insertPosition === 'above';
                props.onDrop(e, insertBefore);
                setIsDragOver(false);
            };

            const handleDragLeave = (e: React.DragEvent) => {
                props.onDragLeave(e);
                setIsDragOver(false);
            };

            const handleDragStart = (e: React.DragEvent) => {
                setIsDragging(true);
                props.onDragStart(e);
            };

            const handleMouseEnter = (e: React.MouseEvent) => {
                if (!isDragging) {
                    setIsHovered(true);
                }
            };

            const handleMouseLeave = (e: React.MouseEvent) => {
                setIsHovered(false);
            };

            const handleDragEnd = (e: React.DragEvent) => {
                props.onDragEnd(e);
                setIsDragging(false);
                setIsHovered(false);
            };

            return {
                id: props.id,
                value: props.value,
                label: props.label,
                isDragOver,
                isHovered,
                isDragging,
                insertPosition,
                canRemove: props.canRemove,
                input: props.input,
                drag: {
                    onStart: handleDragStart,
                    onOver: handleDragOver,
                    onDrop: handleDrop,
                    onLeave: handleDragLeave,
                    onEnd: handleDragEnd,
                },
                hover: {
                    onEnter: handleMouseEnter,
                    onLeave: handleMouseLeave,
                },
                onRemove: props.onRemove,
            };
        },
    };
}
